module.exports = __webpack_public_path__ + "static/favicon-e7d696dfc7c5e92e39a1d6d3fe523c2f.ico";